import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { generateBreadcrumbs, getHomeCategoryBreadcrumb } from '../utils';

/**
 * Get breadcrumbs from categories
 *
 * @description
 * This composable is used to get breadcrumbs from categories
 * in atomic ui Breadcrumb format (PrimeVue).
 *
 * @see https://primevue.org/breadcrumb/
 * @returns {{
 * breadcrumbs: import('primevue/menuitem').MenuItem[],
 * homeCategory: Category
 * }}
 */
export const useBreadcrumbs = () => {
  const { taxonomy } = useCommonProductGetters();
  const categories = taxonomy.value.categories || [];
  const breadcrumbs = generateBreadcrumbs(categories);
  const homeCategory = getHomeCategoryBreadcrumb(categories);

  return {
    breadcrumbs,
    homeCategory,
  };
};

export default useBreadcrumbs;
